export default {
  priority: 94,
  name: app.translate(
    "routes.home.attendance.leave.user leave amount transfer"
  ),
  path: "AmountLeave",
  permissions: [
    "TimeAttendanceMenu/RemainingLeaveMenu/UserLeaveTransferMenu",
  ],
  component: load(() =>
    import(/* webpackChunkName: "amount" */ "./TransferLeave")
  ),
  icon: "folder-account",
  drawer: true,
};
